// src/v2/utils/kasaSesi.js
// Yeni siparis bildirimi icin para sesi.
//
// Once /sounds/para_sesi.mp3 denenir; yuklenemezse Web Audio ile
// sentezlenen "ka-ching" yedegi calar.
//
// NOT: Tarayicilar, kullanici sayfaya dokunmadan once ses calmayi
// engeller. Ilk etkilesimde sesiUyandir() cagrilmalidir.

const SES_YOLU = '/sounds/para_sesi.mp3';

let audio = null;
let dosyaBozuk = false;
let ctx = null;

function audioAl() {
  if (audio) return audio;
  try {
    audio = new Audio(SES_YOLU);
    audio.preload = 'auto';
    audio.addEventListener('error', () => { dosyaBozuk = true; });
  } catch (err) {
    dosyaBozuk = true;
  }
  return audio;
}

function baglamAl() {
  if (ctx) return ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  ctx = new AC();
  return ctx;
}

// Ilk kullanici etkilesiminde cagrilir.
// Sessiz bir calma denemesiyle tarayici iznini alir.
export function sesiUyandir() {
  const a = audioAl();
  if (a && !dosyaBozuk) {
    const eskiSes = a.volume;
    a.volume = 0;
    const s = a.play();
    if (s && typeof s.then === 'function') {
      s.then(() => {
        a.pause();
        a.currentTime = 0;
        a.volume = eskiSes;
      }).catch(() => {
        a.volume = eskiSes;
      });
    }
  }

  const c = baglamAl();
  if (c && c.state === 'suspended') c.resume();
}

// ---- Yedek: sentezlenmis ka-ching ----

function vurus(c, cikis, frekans, baslangic, sure, guc) {
  [1, 2.01, 2.98].forEach((carpan, i) => {
    const osc = c.createOscillator();
    const kaz = c.createGain();
    osc.type = 'sine';
    osc.frequency.value = frekans * carpan;

    const seviye = guc / (i + 1.6);
    kaz.gain.setValueAtTime(0.0001, baslangic);
    kaz.gain.exponentialRampToValueAtTime(seviye, baslangic + 0.006);
    kaz.gain.exponentialRampToValueAtTime(0.0001, baslangic + sure);

    osc.connect(kaz);
    kaz.connect(cikis);
    osc.start(baslangic);
    osc.stop(baslangic + sure + 0.05);
  });
}

function yedekSes(sesSeviyesi) {
  const c = baglamAl();
  if (!c) return;
  if (c.state === 'suspended') c.resume();

  const ana = c.createGain();
  ana.gain.value = typeof sesSeviyesi === 'number' ? sesSeviyesi : 0.5;
  ana.connect(c.destination);

  const t = c.currentTime + 0.02;
  vurus(c, ana, 1568, t, 0.28, 0.34);
  vurus(c, ana, 2093, t + 0.085, 0.75, 0.30);
  vurus(c, ana, 2637, t + 0.095, 0.70, 0.20);

  setTimeout(() => { try { ana.disconnect(); } catch (e) { /* yoksay */ } }, 1500);
}

// ---- Ana giris ----

export function kasaSesiCal(sesSeviyesi) {
  const seviye = typeof sesSeviyesi === 'number' ? sesSeviyesi : 0.7;

  if (dosyaBozuk) { yedekSes(seviye); return; }

  const a = audioAl();
  if (!a) { yedekSes(seviye); return; }

  try {
    a.volume = Math.max(0, Math.min(1, seviye));
    a.currentTime = 0;
    const s = a.play();
    if (s && typeof s.then === 'function') {
      s.catch(() => { yedekSes(seviye); });
    }
  } catch (err) {
    yedekSes(seviye);
  }
}

export default kasaSesiCal;
